"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'tekionicon_vr' !important;\n  font-size: ", ";\n  transform: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke-dasharray: ", ";\n  stroke-dashoffset: ", ";\n  fill: none;\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-linejoin: round;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSvg = _styledComponents["default"].svg.attrs({
  width: function width(_ref) {
    var squareSize = _ref.squareSize;
    return squareSize;
  },
  height: function height(_ref2) {
    var squareSize = _ref2.squareSize;
    return squareSize;
  },
  viewBox: function viewBox(_ref3) {
    var _viewBox = _ref3.viewBox;
    return _viewBox;
  }
})(_templateObject());

var StyledOuterCircle = _styledComponents["default"].circle.attrs({
  cx: function cx(props) {
    return props.squareSize / 2;
  },
  cy: function cy(props) {
    return props.squareSize / 2;
  },
  r: function r(_ref4) {
    var radius = _ref4.radius,
        borderWidth = _ref4.borderWidth;
    return radius - 1.5 * borderWidth;
  },
  strokeWidth: function strokeWidth(props) {
    return "".concat(props.borderWidth, "px");
  }
})(_templateObject2(), function (props) {
  return props.backgroundColor;
});

var StyledInnerCircle = _styledComponents["default"].circle.attrs({
  cx: function cx(props) {
    return props.squareSize / 2;
  },
  cy: function cy(props) {
    return props.squareSize / 2;
  },
  r: function r(props) {
    return props.radius;
  },
  strokeWidth: function strokeWidth(props) {
    return "".concat(props.borderWidth, "px");
  },
  // Start progress marker at 12 O'Clock
  transform: function transform(props) {
    return "rotate(-90 ".concat(props.squareSize / 2, " ").concat(props.squareSize / 2, ")");
  }
})(_templateObject3(), function (props) {
  return props.dashArray;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.borderColor;
}); //style={{ fontFamily: 'tekionicon', fontSize: '24px', transform: 'translate(calc(50% - 12px), calc(50% + 12px - 2px))' }


var StyledIcon = _styledComponents["default"].text(_templateObject4(), function (props) {
  return "".concat(props.iconSize, "px");
}, function (_ref5) {
  var iconSize = _ref5.iconSize,
      borderWidth = _ref5.borderWidth;
  return "translate(calc(50% - ".concat(iconSize / 2, "px), calc(50% + ").concat(iconSize / 2, "px - ").concat(borderWidth / 2, "px))");
});

var CircularProgress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CircularProgress, _React$Component);

  function CircularProgress() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CircularProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CircularProgress)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      percent: 0
    });

    _defineProperty(_assertThisInitialized(_this), "percentRAF", null);

    _defineProperty(_assertThisInitialized(_this), "animatePercent", function () {
      if (!_this._mounted) {
        return;
      }

      var oldPercent = _this.state.percent;
      var newPercent = _this.props.percent;
      var parsedOldPercent = isNaN(oldPercent) ? 0 : oldPercent;
      var parsedNewPercent = isNaN(newPercent) ? 0 : newPercent;
      if (parsedOldPercent === parsedNewPercent) return;
      _this.percentRAF = requestAnimationFrame(function () {
        var percent = parsedOldPercent < parsedNewPercent ? parsedOldPercent + 1 : parsedOldPercent - 1;

        _this.setState({
          percent: percent
        });

        _this.animatePercent();
      });
    });

    return _this;
  }

  _createClass(CircularProgress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      this.animatePercent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevNewPercent = prevProps.percent;
      var newPercent = this.props.percent;

      if (prevNewPercent !== newPercent) {
        cancelAnimationFrame(this.percentRAF);
        this.animatePercent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.percentRAF);
      this._mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          squareSize = _this$props.squareSize,
          borderColor = _this$props.borderColor,
          borderWidth = _this$props.borderWidth,
          iconSize = _this$props.iconSize,
          icon = _this$props.icon,
          backgroundColor = _this$props.backgroundColor;
      var percent = this.state.percent; // SVG centers the stroke width on the radius, subtract out so circle fits in square

      var radius = (squareSize - borderWidth) / 2; // Enclose cicle in a circumscribing square

      var viewBox = "0 0 ".concat(squareSize, " ").concat(squareSize); // Arc length at 100% coverage is the circle circumference

      var dashArray = radius * Math.PI * 2; // Scale 100% coverage overlay with the actual percent

      var dashOffset = dashArray - dashArray * percent / 100;
      return _react["default"].createElement(StyledSvg, {
        viewBox: viewBox,
        squareSize: squareSize
      }, _react["default"].createElement("g", null, _react["default"].createElement(StyledOuterCircle, {
        borderWidth: borderWidth,
        squareSize: squareSize,
        radius: radius,
        backgroundColor: backgroundColor
      }), _react["default"].createElement(StyledInnerCircle, {
        borderWidth: borderWidth,
        squareSize: squareSize,
        radius: radius,
        borderColor: borderColor,
        dashArray: dashArray,
        dashOffset: dashOffset
      }), _react["default"].createElement(StyledIcon, {
        iconSize: iconSize,
        borderWidth: borderWidth
      }, icon)));
    }
  }]);

  return CircularProgress;
}(_react["default"].Component);

CircularProgress.ICONS = {
  HAPPY: "\uE91E",
  NEUTRAL: "\uE921",
  SAD: "\uE91D"
};
CircularProgress.propTypes = {
  squareSize: _propTypes["default"].number,
  borderColor: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  borderWidth: _propTypes["default"].number,
  iconSize: _propTypes["default"].number,
  percent: _propTypes["default"].number,
  icon: _propTypes["default"].oneOf(Object.keys(CircularProgress.ICONS))
};
CircularProgress.defaultProps = {
  squareSize: 36,
  backgroundColor: '#EFEFEF',
  borderColor: 'green',
  borderWidth: 4,
  iconSize: 16
};
CircularProgress.displayName = 'CircularProgress';
var _default = CircularProgress;
exports["default"] = _default;